import { IHashMap } from '@adaptiva/core/common';
import { MetadataObject } from '@adaptiva/metadata/common';

export class MetadataHistoryObjectRow {

	public commitId: string;

	public object: MetadataObject;

	public propertiesRemoved: string[];

	public propertiesAdded: IHashMap<string>;

	public propertiesChanged: IHashMap<string[]>;

	public datetime: number;

	public userLogin: string;

	public operationPerformed: string;

	public objectsInvolved: int[];

	public description: string;

}
